/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPayorFormDefinition } from './HchbPayorFormDefinition';
import {
    HchbPayorFormDefinitionFromJSON,
    HchbPayorFormDefinitionFromJSONTyped,
    HchbPayorFormDefinitionToJSON,
    HchbPayorFormDefinitionToJSONTyped,
} from './HchbPayorFormDefinition';

/**
 * 
 * @export
 * @interface GetHchbPayorForm200Response
 */
export interface GetHchbPayorForm200Response {
    /**
     * 
     */
    data: HchbPayorFormDefinition;
}

/**
 * Check if a given object implements the GetHchbPayorForm200Response interface.
 */
export function instanceOfGetHchbPayorForm200Response(value: object): value is GetHchbPayorForm200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function GetHchbPayorForm200ResponseFromJSON(json: any): GetHchbPayorForm200Response {
    return GetHchbPayorForm200ResponseFromJSONTyped(json, false);
}

export function GetHchbPayorForm200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetHchbPayorForm200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': HchbPayorFormDefinitionFromJSON(json['data']),
    };
}

export function GetHchbPayorForm200ResponseToJSON(json: any): GetHchbPayorForm200Response {
    return GetHchbPayorForm200ResponseToJSONTyped(json, false);
}

export function GetHchbPayorForm200ResponseToJSONTyped(value?: GetHchbPayorForm200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': HchbPayorFormDefinitionToJSON(value['data']),
    };
}

